import { createEntitiesSlice } from "~/Redux/Entities";
import { missingSpaceSchema } from "../schema";
import { Space } from "../types";

export const { reducer: missingSpacesEntitiesReducer, updateEntities: updateMissingSpaces } =
    createEntitiesSlice<Space>(missingSpaceSchema, {
        initState: null,
        ignoreCleanEntities: true,
    });
